export default {
    "meta": {
        "title": "Running Custom Code on OKX",
        "description": "Discover how to execute custom trading scripts on the OKX exchange and enhance your trading capabilities."
    },
    "hero": {
        "notification": "Explore flexible solutions for OKX.",
        "h1": "Running Custom Code on OKX",
        "paragraph1": "Customizing trading strategies on OKX offers traders the ability to programmatically manage trades, analyze markets, and deploy unique approaches to crypto trading.",
        "paragraph2": "When trading on OKX, many users look for advanced ways to implement their strategies. Using custom scripts not only allows you to adapt to the market but also provides unparalleled control over trading decisions. Learn how tools like Gunbot extend these capabilities, giving you more freedom in how your code interacts with OKX. Also, save a lot of time.",
        "chartSymbol": "BTC/USD",
        "chartFeatures": [
            {
                "id": 1,
                "title": "Visualize Script Execution",
                "description": "Track the real-time effects of your custom scripts with trade visualization."
            },
            {
                "id": 2,
                "title": "Analyze Multi-Timeframe Trends",
                "description": "Strategically monitor market trends across various timeframes for better insights."
            }
        ],
        "reviewHeading": "Why Traders Choose Gunbot"
    },
    "block1": {
        "heading": "Harnessing Custom Scripts for Trading on OKX",
        "paragraph": "Running custom code on OKX involves integrating trading scripts with the exchange's API, allowing for precise trade execution and strategy customization. However, many traders face limitations when working directly with exchange APIs—such as restricted access to market data or complexity in using their methods. Tools like Gunbot fix these challenges by providing a framework that supports fully customizable JavaScript strategies and dynamic automation. With Gunbot, traders can easily write and deploy their own strategies while leveraging OKX's robust trading environment.",
        "imgAlt": "A dynamic trading dashboard showcasing script performance.",
        "featureTitle1": "Complete Strategy Freedom",
        "featureDescription1": "With Gunbot, define every aspect of your trading logic, from indicators to order types.",
        "featureTitle2": "Integrated Data Access",
        "featureDescription2": "Access comprehensive market data directly from OKX, ready for analysis in your scripts.",
        "featureTitle3": "Seamless Execution",
        "featureDescription3": "Deploy your code with tools designed for frequent, precise trades that align with your strategies.",
        "featureTitle4": "Automation and Monitoring",
        "featureDescription4": "Set up scripts to run continuously with real-time monitoring and automated adjustments."
    },
    "quote": {
        "paragraph": "Custom coding opens the door to innovative trading strategies—Gunbot makes it accessible and efficient for every trader."
    },
    "resources": {
        "heading": "Expand Your Knowledge",
        "subheading": "Learn more about trading automation and strategy design.",
        "description": "Explore these resources to understand how Gunbot enhances custom trading capabilities on OKX and other exchanges.",
        "resources": [
            {
                "title": "Examples of Custom Strategies",
                "description": "Dive into detailed JavaScript examples for creating trading strategies.",
                "link": "https://www.gunbot.com/support/docs/custom-strategies/example-strategies/overview/",
                "linkText": "Explore Examples"
            },
            {
                "title": "Supported Exchanges",
                "description": "See the full list of exchanges that integrate with Gunbot.",
                "link": "https://www.gunbot.com/exchanges/",
                "linkText": "View Exchanges"
            },
            {
                "title": "Autoconfig Pair Management",
                "description": "Learn how to dynamically manage trading pairs with autoconfig.",
                "link": "https://www.gunbot.com/support/guides/trading-logic-and-optimization/autoconfig-control-pair-settings/",
                "linkText": "Learn More"
            },
            {
                "title": "OKX Trading Bot",
                "description": "Explore how to integrate Gunbot with OKX for automated trading.",
                "link": "https://www.gunbot.com/exchanges/okx-trading-bot/",
                "linkText": "OKX Trading Bot"
            }
        ]
    },
    "block2": {
        "heading": "Why Choose Tools Like Gunbot for OKX?",
        "paragraph": "While OKX provides traders with a solid platform and API for basic automation, a solution like Gunbot empowers users to take their automation further. By offering features like autoconfig, dynamic data integration, and unlimited customization of trading logic, Gunbot bridges the gap between standard API capabilities and fully customized trading automation. Whether you're building advanced market-making strategies or experimenting with technical indicators, Gunbot delivers the flexibility and control you need to succeed. And save a lot of time doing so.",
        "imgAlt": "A trading chart demonstrating the effects of custom strategies."
    },
    "cta": {
        "text": "Have questions about custom trading scripts on OKX?",
        "linkText": "Contact Us",
        "link": "https://www.gunbot.com/contact/",
        "linkTitle": "Get in Touch"
    },
    "pricing": {
        "heading": "Flexible Plans for Advanced Traders",
        "primaryButtonText": "I want this!",
        "yearlyAdmonition": "-50%",
        "lifetimeAdmonition": "Best value",
        "tabs": {
            "Monthly": [],
            "Annual": [],
            "Lifetime": []
        },
        
        
        "joinGunbotCommunity": "Join Gunbot community",
        "moreDetailsAbout": "More details about"
    }
}
